import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { AppointmentTimePicker } from "@/portals/(shared)/(schedule)/AppointmentTimePicker";
import { Button2 } from "@/ui2/atoms/Button";
import { EarlierAppointmentInfo } from "@/portals/(shared)/(schedule)/AppointmentTimePicker/EarlierAppointmentInfo";
import { getPatientProfile } from "@/redux/actions/auth";
import { getQueryParams } from "@/utils/filters";
import { patientRequests } from "@/api/(requests)/patient";
import { scheduleRequests } from "@/api/(requests)/schedule";

import images from "../../../utils/images";
import { TEENS_AND_KIDS_DIAGNOSTIC_INTERVIEW_90791_ALLOTTED_TIME } from "../../Provider/ScheduleAvailability/constants";
import { trackEvent } from "../../../utils/EventTrackingUtil";

const ScheduleCall = (props) => {
  const { nextStep } = props;
  const patientId = getQueryParams("patientId", props.location.search);

  const [intakeAppointments, setIntakeAppointments] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  useEffect(() => {
    const enrichedAssociatedWards = props.auth.profile.enriched_associated_wards;

    if (
      enrichedAssociatedWards &&
      enrichedAssociatedWards.find((x) => x.patient_id === patientId && x.schedule_video_call)
    ) {
      props.alreadyScheduled(patientId);

      return;
    }
    (async () => {
      // Note: In the absence of a more formal way to dynamically adjust the config from 45 minute DI
      // to 90 minute DI, the backend was expanded to support custom durations for appointments
      const data = {
        id: patientId,
        override_meeting_duration: TEENS_AND_KIDS_DIAGNOSTIC_INTERVIEW_90791_ALLOTTED_TIME,
        timezone: props.auth.timezone,
      };
      const availability = await patientRequests.get_upcoming_intake_availability({ data });

      setIntakeAppointments(availability?.["upcoming_availability"]);
    })();
  }, []);

  const submit = async () => {
    const { day, month, start_time, year } = selectedAppointment;
    const local_date_time = `${year}-${month}-${day} ${start_time}`;

    const data = {
      allotted_time: selectedAppointment["allotted_time"],
      local_date_time,
      patient_id: patientId,
      provider_id: selectedAppointment["provider_username"],
      timezone: props.auth.timezone,
    };

    await scheduleRequests.post_schedule({ data });
    trackEvent("Submit Schedule for Child");
    await props.getPatientProfile();
    nextStep();
  };

  const timePickerProps = {
    appointments: intakeAppointments,
    patientDetails: {
      override_meeting_duration: TEENS_AND_KIDS_DIAGNOSTIC_INTERVIEW_90791_ALLOTTED_TIME,
      username: patientId,
    },
    selectedAppointment,
    setAppointments: setIntakeAppointments,
    setSelectedAppointment,
  };

  return (
    <>
      <div className="txt-sec pt-2 mx-3 workflow-step-title tw:font-bold" data-public>
        Step 3 of 3: Schedule A Therapist Consultation
      </div>

      <div className="mx-4 my-3" data-public>
        <div className="d-md-flex mx-3 my-5">
          <div className="program-details-icon-container">
            <img
              alt="general info"
              className="program-details-icon"
              src={images("./patient/teens_and_kids_program/icn-calendar.svg")}
            />
          </div>

          <div className="ml-4">
            <div className="txt-pri fs-20 tw:font-bold">
              Congratulations, you’ve referred your child to aptihealth!
            </div>

            <div>
              Together, you will attend the therapist session from your{" "}
              <span className="tw:font-bold">child’s account.</span>
            </div>
          </div>
        </div>

        <div>
          {intakeAppointments && <AppointmentTimePicker {...timePickerProps} />}

          {!intakeAppointments && (
            <div className="m-3 font-italic txt-gry">Loading Therapist Availability...</div>
          )}
        </div>

        <div className="tw:my-8 tw:flex tw:justify-center">
          <Button2 isDisabled={selectedAppointment === null} onPress={submit}>
            Continue
          </Button2>
        </div>

        <EarlierAppointmentInfo className="tw:pb-12" />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { getPatientProfile })(withRouter(ScheduleCall));
